module.exports = __webpack_public_path__ + "static/media/shopify5.7dd57b8f.png";